import React, { useEffect, useState } from "react";
import BreadCrumbBanner from "../component/BreadCrumbBanner";
import galleryAPI from "../api/galleryApi";

const Gallery = () => {
  const [gallery, setGallery] = useState([]);

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const res = await galleryAPI.listing();

        if (res.code === 200) {
          const result = res.data;

          setGallery(result?.gallery);
        }
      } catch (error) {
        console.error("Error fetching gallery:", error);
      }
    };

    fetchGallery();
  }, []);

  return (
    <>
      {/* hero section */}
      <BreadCrumbBanner
        title="Gallery"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      {/* gallery page */}
      <section className="mrv-gallery-section py-5">
        <div className="container">
          {/* HEADING */}
          <div className="row mb-4">
            <div className="col-12 text-left">
              <span className="mrv-subtitle">Our Campus Highlights</span>

              <h2 className="mrv-title">Moments at MRV</h2>
            </div>
          </div>

          {/* GRID */}
          <div className="row g-3 row-cols-1 row-cols-md-2 row-cols-lg-3">
            {gallery?.map((item, index) => (
              <div key={item.id} className="col">
                <div className="mrv-gallery-card">
                  <img
                    src={item.gallery_images}
                    className="mrv-gallery-img"
                    alt="Gallery"
                    loading="lazy"
                  />

                  <div className="mrv-gallery-hover">
                    {/* <i className="bi bi-plus" /> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Gallery;
